import React from "react";

import styled from "@emotion/styled";

const Owner = ({ owner }) => {
    const OwnerContainer = styled.div`
        margin-top: 50px;
        width: 100%;
        background-color: ${({ theme }) => theme.colors.blue.toString()};
        ${({ theme }) => theme.paddings.containerOuter.left}
        ${({ theme }) => theme.paddings.containerOuter.right}

        display: flex;
        flex-direction: column;
        justify-content: center;

        ${({ theme }) => theme.breakpoints.from.small.css`
            flex-direction: row;
            gap: 20px;
        `}

        padding-top: 30px;
        padding-bottom: 30px;
        color: ${({ theme }) => theme.colors.white.toString()} !important;
    `;

    const OwnerTitle = styled.strong`
        color: ${({ theme }) => theme.colors.white.toString()};
    `;

    return (
        <>
            <OwnerContainer>
                <OwnerTitle>Betreiber:</OwnerTitle>
                <div>{owner.inhaber_firma}</div>
                <div>{owner.inhaber_name}</div>
                <div>
                    {owner.inhaber_anschrift && owner.inhaber_anschrift.strasse}{" "}
                    {owner.inhaber_anschrift && owner.inhaber_anschrift.nummer}
                </div>
                <div>
                    {owner.inhaber_anschrift && owner.inhaber_anschrift.ort}
                </div>
                <div>{owner.inhaber_handelsregister}</div>
            </OwnerContainer>
        </>
    );
};

export default Owner;
